import { Button } from '@talentmesh/ui/components/button';
import { InputGroup, InputGroupAddon, InputGroupInput } from '@talentmesh/ui/components/input-group';
import { cn } from '@talentmesh/ui/lib/utils';
import { Filter, Search } from 'lucide-react';
import { useState } from 'react';
import IdentifiedButtonActions from '../IdentifiedButtonActions';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import { useIdentifiedTableContext } from '../utils/IdentifiedTableContext';
import AdvancedFilters from './AdvancedFilters';
import TableToolbar from '@/Components/Table/TableToolbar';
import UIStrings from '@/Utils/UIStrings';

const IdentifiedListToolbar = () => {
    const table = useIdentifiedTableContext();
    const { options, setOptions } = useIdentifiedListContext();
    const selectedRows = table.getSelectedRowModel().rows;
    const showButtons = selectedRows.length > 0;
    // mounting/unmounting advanced filters cause the table to reload for unknown reason
    // use css to hide and unhide advanced filters
    const [openFilter, setOpenFilter] = useState(false);

    const getSelectedRowIds = (): Array<string> => {
        return selectedRows.map((item) => item.original.id);
    };

    return (
        <TableToolbar>
            {showButtons && (
                <div className="animate-in fade-in slide-in-from-bottom-1 flex flex-row items-center gap-2 duration-200 ease-out">
                    <span className="text-sm font-bold">
                        {selectedRows.length} {UIStrings.Selected}
                    </span>
                    <IdentifiedButtonActions selectedRowIds={getSelectedRowIds()} />
                </div>
            )}
            <div className="ml-auto" />
            <div className={openFilter ? 'visible' : 'invisible'}>
                <AdvancedFilters />
            </div>
            <InputGroup data-cy="ProfileNameSearchBar" className="max-w-64">
                <InputGroupInput
                    name="profileNameSearch"
                    placeholder={UIStrings.SearchByName}
                    value={options.search || ''}
                    onChange={(e) => setOptions((p) => ({ ...p, search: e.target.value }))}
                />
                <InputGroupAddon>
                    <Search />
                </InputGroupAddon>
            </InputGroup>
            <Button
                type="button"
                variant="ghost"
                size="icon"
                data-cy="toggleAdvancedFilterButton"
                aria-pressed={openFilter}
                aria-label={UIStrings.Filter}
                onClick={() => setOpenFilter(!openFilter)}
                className={cn(
                    'rounded-lg transition-colors',
                    openFilter ? 'bg-accent text-primary' : 'text-muted-foreground',
                )}
            >
                <Filter className="h-5 w-5" />
            </Button>
        </TableToolbar>
    );
};

export default IdentifiedListToolbar;
